import { Checkbox, Collapse } from "antd";
import { FC } from "react";

import { StyledCheckboxGroup } from "./AutoGeneratedFilters.styled";

interface AutoGeneratedFiltersProps {
    availableFilters: Record<
        string,
        { title: string; options: (string | number | boolean)[] }
    >;
    selectedFilters: Record<string, (string | number | boolean)[]>;
    onFilterChange: (
        tag: string,
        values: (string | number | boolean)[],
    ) => void;
}

export const AutoGeneratedFilters: FC<AutoGeneratedFiltersProps> = ({
    availableFilters,
    selectedFilters,
    onFilterChange,
}) => {
    const formatValue = (value: string | number | boolean) => {
        if (typeof value === "boolean") {
            return value ? "Так" : "Ні";
        }
        return String(value);
    };

    const collapseItems = Object.entries(availableFilters).map(
        ([tag, { title, options }]) => ({
            key: tag,
            label: title,
            children: (
                <StyledCheckboxGroup
                    value={selectedFilters[tag] || []}
                    onChange={(values) =>
                        onFilterChange(
                            tag,
                            values as (string | number | boolean)[],
                        )
                    }
                >
                    {options.map((option) => (
                        <Checkbox key={String(option)} value={option}>
                            {formatValue(option)}
                        </Checkbox>
                    ))}
                </StyledCheckboxGroup>
            ),
        }),
    );

    return <Collapse destroyOnHidden={false} items={collapseItems} />;
};
